import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GetProductByIdSale,
  GetSaleOrderDetailsByID,
  GetSaleOrderCustomerByID,
  DeleteEditSaleOrderProduct,
  EditEstimationApi,
  getProductFilterSubString,
  GetAccToIdBySaleOrder1,
  GetUnitByProductId,
  GetGenerateEstimate,
} from "../../api";
import { Header } from "../../components";
import Select from "react-select";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/sale.css";
import { Card } from "react-bootstrap";
import "../../styles/viewCustomer.css";
import { Col, Container, Row } from "react-bootstrap";
import { ValidOrderField } from "../../contexts/Utils";

const EditEstimation = () => {
  const {
    currentColor,
    defaultImageMode,
    imageMode,
    setActiveProdMenu,
    setActiveProdMenuId,
    userID,
    userToken,
  } = useStateContext();
  const navigate = useNavigate();
  const [ProductStr, setProductStr] = useState("");
  const [product, setProducts] = useState("");
  const [qty, setqty] = useState(1.0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [productOptions, setProductOptions] = useState([]);
  const [p_code, setp_code] = useState("");
  const [customer_ids, setcustomer_ids] = useState("");
  const [CardList, setcartList] = useState([]);
  const [total_amount, settotalAmount] = useState(0);
  const [tax, settax] = useState(0);
  const [totaldiscount, settotaldiscount] = useState(0.0);
  const [total_item, settotalitem] = useState(0);
  const [index1, setindex1] = useState("");
  const [grandtotal, setgrandtotal] = useState(0);
  const [note, setnote] = useState("");
  const [projectname, setprojectname] = useState("");
  const [projectname1, setprojectname1] = useState("");
  const [cusFlag, setcusFlag] = useState("");
  const [invoice_id, setinvoice_id] = useState("");
  const [projectname2, setprojectname2] = useState(0);
  const [deleteprodList, setdeleteprodList] = useState([]);
  const [acc_from_bal, setacc_from_bal] = useState("");
  const [store_id_param, setstore_id_param] = useState("");
  const [dot, setdot] = useState(0);
  const [isPageFrozen, setIsPageFrozen] = useState(false);
  const [saveClick, setsaveClick] = useState(false);
  const [print_flag, setprint_flag] = useState(false);
  let param = useParams();
  var so_id_param = param.so_ids;

  const [formData] = useState({
    so_id: 0,
    est_sale: "E",
    customer_po_no: "",
    customer_id: 0,
    project_name: "",
    total: 0,
    amount_paid: 0,
    amount_pending: 0,
    user_id: null,
    so_note: "",
    total_price: 0,
    discount: 0,
    tax: 0,
    shipment: 0,
    store_id: 0,
    invoice_id: 0,
    sale_products: [],
    shipments: [],
  });

  const [formData1, setFormData1] = useState({
    so_id: so_id_param,
    store_id: 0,
    invoice_id: 0,
    product_id: 0,
  });

  const keypadButtons = [
    "7",
    "8",
    "9",
    "4",
    "5",
    "6",
    "1",
    "2",
    "3",
    ".",
    "0",
    "00",
  ];

  const [activeInput, setActiveInput] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [UnitOptions, setUnitOptions] = useState([]);
  const [GetUnit, setGetUnit] = useState([]);
  const [oDatetime, setODatetime] = useState("");

  const handleInputClick = (inputId, index) => {
    TimeoutUtility.resetTimeout();
    setActiveInput(inputId);
    setindex1(index);
  };

  const handleKeypadClick = (value) => {
    TimeoutUtility.resetTimeout();
    if (activeInput !== null) {
      const newCartList = [...CardList];
      const indexToUpdate = index1;

      if (
        activeInput === "quantity" ||
        activeInput === "unit_price" ||
        activeInput === "discount" ||
        activeInput === "shipment"
      ) {
        var currentValue = String(
          newCartList[indexToUpdate][activeInput] || ""
        );
        if (value === "." && currentValue.includes(".")) {
          return;
        }

        if (value === "." && !currentValue.includes(".")) {
          if (currentValue === "") {
            currentValue = "0";
          }
          newCartList[indexToUpdate][activeInput] = currentValue + ".0";
          setcartList(newCartList);
          setdot(1);
          return;
        }
        var newValue = currentValue + String(value);
        if (dot === 1) {
          var [integerPart] = currentValue.split(".");
          if (integerPart === "") {
            integerPart = "0";
          }
          newValue = integerPart + "." + value;
          setdot(0);
        }

        if (!isNaN(newValue)) {
          newCartList[indexToUpdate][activeInput] = newValue;
          newCartList[indexToUpdate].total =
            (newCartList[indexToUpdate].unit_price -
              newCartList[indexToUpdate].discount) *
            newCartList[indexToUpdate].quantity;

          setcartList(newCartList);
          setdot(0);
        }
      } else if (activeInput === "tax" && index1 === -2) {
        var currentTaxValue = String(tax || "");

        if (value === "." && currentTaxValue.includes(".")) {
          return;
        }
        if (value === "." && !currentTaxValue.includes(".")) {
          if (currentTaxValue === "") {
            currentTaxValue = "0";
          }
          settax(currentTaxValue + ".0");
          setdot(1);
          return;
        }
        newValue = currentTaxValue + String(value || "");
        if (dot === 1) {
          var [integerPart0] = currentTaxValue.split(".");
          if (integerPart0 === "") {
            integerPart0 = "0";
          }
          newValue = integerPart0 + "." + value;
          setdot(0);
        }
        if (!isNaN(newValue)) {
          settax(newValue);
        }
      } else if (activeInput === "shipment1" && index1 === -3) {
        var currentShipmentValue = String(projectname2 || "");

        if (value === "." && currentShipmentValue.includes(".")) {
          return;
        }
        if (value === "." && !currentShipmentValue.includes(".")) {
          if (currentShipmentValue === "") {
            currentShipmentValue = "0";
          }
          setprojectname2(currentShipmentValue + ".0");
          setdot(1);
          return;
        }
        newValue = currentShipmentValue + String(value || "");
        if (dot === 1) {
          var [integerPart1] = currentShipmentValue.split(".");
          if (integerPart1 === "") {
            integerPart1 = "0";
          }
          newValue = integerPart1 + "." + value;
          setdot(0);
        }
        if (!isNaN(newValue)) {
          setprojectname2(newValue);
        }
      } else if (activeInput === "qty" && index1 === -8) {
        var currentQtyValue = String(qty || "");

        if (value === "." && currentQtyValue.includes(".")) {
          return;
        }
        if (value === "." && !currentQtyValue.includes(".")) {
          if (currentQtyValue === "") {
            currentQtyValue = "0";
          }
          setqty(currentQtyValue + ".0");
          setdot(1);
          return;
        }
        newValue = currentQtyValue + String(value || "");
        if (dot === 1) {
          var [integerPart3] = currentQtyValue.split(".");
          if (integerPart3 === "") {
            integerPart3 = "0";
          }
          newValue = integerPart3 + "." + value;
          setdot(0);
        }
        if (!isNaN(newValue)) {
          setqty(newValue);
        }
      } else if (activeInput === "uprice" && index1 === -9) {
        var currentUPValue = String(unitPrice || "");

        if (value === "." && currentUPValue.includes(".")) {
          return;
        }
        if (value === "." && !currentUPValue.includes(".")) {
          if (currentUPValue === "") {
            currentUPValue = "0";
          }
          setUnitPrice(currentUPValue + ".0");
          setdot(1);
          return;
        }
        newValue = currentUPValue + String(value || "");
        if (dot === 1) {
          var [integerPart4] = currentUPValue.split(".");
          if (integerPart4 === "") {
            integerPart4 = "0";
          }
          newValue = integerPart4 + "." + value;
          setdot(0);
        }
        if (!isNaN(newValue)) {
          setUnitPrice(newValue);
        }
      }
    }
  };

  const handleAddcartClick = () => {
    TimeoutUtility.resetTimeout();
    if (qty <= 0) {
      alert("Quantity should be greater than 0!");
      return;
    } else if (selectedUnit === null) {
      alert("Select Unit!");
      return;
    } else if (product.value && userID && userToken) {
      let qtyy = qty;
      let upp = unitPrice;
      if (selectedUnit === UnitOptions[1]) {
        qtyy = qty / selectedUnit.conv;
        upp = unitPrice / UnitOptions[0].conv;
      }
      const resp1 = GetProductByIdSale(
        p_code,
        store_id_param,
        userID,
        userToken
      );
      resp1
        .then(function (result) {
          const defaultProduct = {
            product_id: result.data[0].product_id,
            name: result.data[0].name,
            code: result.data[0].code,
            unit_price: upp,
            unit: UnitOptions[0].label,
            cost_price: result.data[0].cost_price,
            quantity: qtyy,
            item_no: 0,
            discount: result.data[0].discount,
            total: (unitPrice - result.data[0].discount) * qty,
            shipment: qtyy,
            image: result.data[0].image,
            image_url: result.data[0].image_url,
            req_delivery_date: null,
            details: result.data[0].details,
            // supplier_id: supplier_ids,
            // supplier_name: supplier_name,
            notes: "",
          };

          setcartList((prevProductList) => [
            defaultProduct,
            ...prevProductList,
          ]);
          setProducts("");

          setProductOptions((prevOptions) =>
            prevOptions.filter(
              (option) => option.values !== result.data[0].product_id
            )
          );
        })
        .catch((err) => {
          console.log(err.message);
        });
    }
    setSelectedProduct("");
    setSelectedUnit("");
    setUnitOptions([]);
    setqty(1);
    setUnitPrice(0);
  };

  const handleChangeUnit = (selectedOption) => {
    TimeoutUtility.resetTimeout();
    if (selectedOption && selectedOption.value) {
      if (selectedOption !== selectedUnit) {
        setUnitPrice(unitPrice / selectedOption.conv);
      }
      setSelectedUnit(selectedOption);
      setActiveInput("unit");
      document.getElementById("qty").focus();
    } else {
      // setSelectedUnit(null);
      // setActiveInput("unit");
    }
  };

  const handleChangeUnit1 = (selectedOption, event) => {
    TimeoutUtility.resetTimeout();
    if (event.key === "Enter" && selectedOption && selectedOption.value) {
      if (selectedOption !== selectedUnit) {
        setUnitPrice(unitPrice / selectedOption.conv);
      }
      setSelectedUnit(selectedOption);
      setActiveInput("unit");
      document.getElementById("qty").focus();
    } else {
      // setSelectedUnit(null);
      // setActiveInput("unit");
    }
  };

  const handleChangeProduct = async (selectedOption) => {
    TimeoutUtility.resetTimeout();
    if (selectedOption && selectedOption.values && userID && userToken) {
      setSelectedProduct(selectedOption);
      setqty(1);
      setUnitPrice(selectedOption.price);
      await GetUnitByProductId(selectedOption.values, userID, userToken)
        .then((resp) => {
          setGetUnit(resp.data || []);
        })
        .catch((err) => {
          console.log(err.message);
        });
      var ProductStr1 = ProductStr;
      ProductStr1 = ProductStr1 + selectedOption.values + " ";
      setProductStr(ProductStr1);
      setActiveInput("product");
      setProducts(selectedOption);
      const selectedProduct = selectedOption.values;
      setp_code(selectedProduct);
      document.getElementById("unit").focus();
    }
  };

  const handleNotesChange = (index, value) => {
    const newCartList = [...CardList];
    newCartList[index].notes = value;
    setcartList(newCartList);
    setActiveInput("notes");
    setindex1(index);
  };

  const handleChangeNote = (e) => {
    setnote(e.target.value);
  };

  const handleChangeProjectName2 = (e) => {
    setActiveInput("shipment1");
    setprojectname2(e.target.value);
    setindex1(-3);
  };

  const handleChangeProjectName = (e) => {
    setprojectname(e.target.value);
  };

  const handleChangeProjectName1 = (e) => {
    setprojectname1(e.target.value);
  };

  const handleSaleOrderClick = async (e) => {
    TimeoutUtility.resetTimeout();
    if (CardList.length === 0) {
      alert("Estimation cart is empty.");
      return;
    }
    setIsPageFrozen(true);
    setsaveClick(!saveClick);
  };

  const handlePrintOrderClick = async (e) => {
    setprint_flag(true);
    handleSaleOrderClick();
  };

  useEffect(() => {
    async function SaveOrder() {
      if (saveClick && userID && userToken) {
        const updatedFormData = { ...formData };

        updatedFormData.tax = tax;
        updatedFormData.project_name = projectname;
        updatedFormData.customer_po_no = projectname1;
        updatedFormData.shipment = projectname2;
        updatedFormData.so_id = so_id_param;
        updatedFormData.est_sale = "E";
        updatedFormData.customer_id = customer_ids;
        updatedFormData.total = grandtotal;
        updatedFormData.amount_pending = grandtotal;
        updatedFormData.amount_paid = 0.0;
        updatedFormData.so_note = note;
        updatedFormData.total_price = grandtotal;
        updatedFormData.discount = totaldiscount;
        updatedFormData.invoice_id = invoice_id;
        updatedFormData.store_id = store_id_param;
        updatedFormData.user_id = userID;
        updatedFormData.sale_products = [];

        console.log(updatedFormData);

        const uniqueValues = new Set(
          CardList.map((v) => String(v.product_id) + v.notes)
        );

        if (uniqueValues.size < CardList.length) {
          alert(
            `Duplicate notes for same products found.\nSales Order failed to create.`
          );
          setsaveClick(!saveClick);
          setIsPageFrozen(false);
          return;
        } else {
          CardList.forEach((product, index) => {
            var dt = null;
            if (
              product.req_delivery_date !== null ||
              product.req_delivery_date !== ""
            ) {
              dt = product.req_delivery_date;
            }
            const saleProduct = {
              product_id: product.product_id,
              supplier_id: product.supplier_id,
              item_no: product.item_no,
              quantity: product.quantity,
              price: product.unit_price,
              cost_price: product.cost_price,
              item_note: product.notes,
              discount: product.discount,
              req_delivery_date: dt,
            };
            updatedFormData.sale_products.push(saleProduct);
          });

          if (deleteprodList.length === 0) {
          } else {
            DeleteProductfrom_SaleOrder();
          }

          const response = await EditEstimationApi(
            updatedFormData,
            userID,
            userToken
          );
          if (response.status === 200) {
            if (
              print_flag &&
              so_id_param &&
              store_id_param &&
              userID &&
              userToken
            ) {
              const res1 = await GetGenerateEstimate(
                store_id_param,
                so_id_param,
                userID,
                userToken
              );
              if (res1.data) {
                const pdfBlob = new Blob([res1.data], {
                  type: "application/pdf",
                });
                const pdfURL = URL.createObjectURL(pdfBlob);
                const newWindow = window.open(pdfURL);
                if (newWindow) {
                  // Wait for PDF to load, then print
                  newWindow.addEventListener("load", () => {
                    newWindow.focus();
                    newWindow.print();
                  });
                }
              }
              alert("Estimation updated successfully.");
              setprint_flag(false);
            }
            if (!print_flag) {
              alert("Estimation updated successfully.");
            }
          } else {
            alert("Estimation failed to update.");
            setsaveClick(!saveClick);
            setIsPageFrozen(false);
            return;
          }
          setsaveClick(!saveClick);
          setIsPageFrozen(false);
          window.location.reload();
        }
      }
    }
    SaveOrder();
  }, [saveClick]);

  const handleViewEmployeesClick2 = async (event) => {
    event.preventDefault();
    try {
      const so_ids = so_id_param + "_" + store_id_param;
      const path = `/Estimates/ConvertEstimate/${so_ids}`;
      if (
        window.confirm(
          `Are you sure you want to convert this Estimate into SO?`
        )
      ) {
        navigate(path);
        // window.open(path, "_blank");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleClearClick = async (event) => {
    if (window.confirm(`Are you sure you want to Clear the Estimate?`)) {
      window.location.reload();
    }
  };

  const handleToggle = (value) => {
    setActiveProdMenuId({
      product_id: value.product_id,
      store_id: store_id_param,
    });
    setActiveProdMenu(true);
  };

  const handleNewClick = async (event) => {
    event.preventDefault();
    try {
      const path = `/Estimates/AddEstimation/${store_id_param}`;
      window.open(path, "_blank");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const CalculateAllFields = () => {
    let total_amt = 0,
      total_itm = 0;
    let total_dis = 0;
    let grandTotal = 0.0;
    let taxx = 0,
      dd = 0;

    if (tax) {
      taxx = parseFloat(tax);
    }

    for (let i = 0; i < CardList.length; i++) {
      let a = 0,
        b = 0,
        c = 0;
      if (CardList[i].total) {
        a = parseFloat(CardList[i].total);
      }
      if (CardList[i].discount) {
        b = parseFloat(CardList[i].discount);
      }
      if (CardList[i].quantity) {
        c = parseFloat(CardList[i].quantity);
      }
      if (projectname2) {
        dd = parseFloat(projectname2);
      }
      total_amt = total_amt + a + b * c;
      total_dis = total_dis + b * c;
      total_itm = total_itm + c;
    }
    settotaldiscount(total_dis);
    settotalAmount(total_amt);
    settotalitem(total_itm);
    taxx = (taxx / 100) * (total_amt - total_dis);
    grandTotal = total_amt - total_dis + taxx + dd;

    setgrandtotal(grandTotal);
  };

  const handleBackClick = async (event) => {
    if (
      window.confirm(
        `Are you sure you want to Close without saving the changes?`
      )
    ) {
      window.close();
    }
  };

  const handleUnitPriceChange = (index, value) => {
    TimeoutUtility.resetTimeout();
    const newCartList = [...CardList];
    newCartList[index].unit_price = value;
    newCartList[index].total =
      value * parseFloat(newCartList[index].quantity) -
      parseFloat(newCartList[index].quantity) *
        parseFloat(newCartList[index].discount);
    setcartList(newCartList);
    setActiveInput("unit_price");
    setindex1(index);
  };

  const handleQuantityChange = (index, value) => {
    TimeoutUtility.resetTimeout();
    const newCartList = [...CardList];
    if (!ValidOrderField(value)) {
      if (value !== "") {
        newCartList[index].quantity = 0;
        newCartList[index].shipment = 0;
        newCartList[index].total =
          value * parseFloat(newCartList[index].unit_price) -
          value * parseFloat(newCartList[index].discount);
        setcartList(newCartList);
        setActiveInput("quantity");
        setindex1(index);
        return;
      }
    }
    newCartList[index].quantity = value;
    newCartList[index].shipment = value;
    newCartList[index].total =
      value * parseFloat(newCartList[index].unit_price) -
      value * parseFloat(newCartList[index].discount);
    setcartList(newCartList);
    setActiveInput("quantity");
    setindex1(index);
  };

  const handleDiscountChange = (index, value) => {
    const newCartList = [...CardList];
    newCartList[index].discount = value;
    newCartList[index].total =
      newCartList[index].quantity * newCartList[index].unit_price -
      newCartList[index].quantity * value;
    setcartList(newCartList);
    setActiveInput("discount");
    setindex1(index);
  };

  const formatCurrency = (number) => {
    return number.toLocaleString("en-PK", {
      style: "currency",
      currency: "PKR",
      minimumFractionDigits: 2,
    });
  };

  const handleChangeTax = (e) => {
    setActiveInput("tax");
    settax(e.target.value);
    setindex1(-2);
  };

  const handleChangeQty = (e) => {
    setActiveInput("qty");
    setqty(e.target.value);
    //setindex1(-2);
  };

  const handleEnterQty = (e) => {
    if (e.key === "Enter") {
      document.getElementById("uprice").focus();
    }
  };

  const handleChangeUPrice = (e) => {
    setActiveInput("uprice");
    setUnitPrice(e.target.value);
    //setindex1(-2);
  };

  const handleEnterUPrice = (e) => {
    if (e.key === "Enter") {
      handleAddcartClick();
      document.getElementById("product").focus();
    }
  };

  const DeleteProductfrom_SaleOrder = async () => {
    const updatedFormData = { ...formData1 };
    updatedFormData.store_id = store_id_param;
    updatedFormData.invoice_id = invoice_id;
    setFormData1(updatedFormData);
    try {
      await Promise.all(
        deleteprodList.map(async (item) => {
          if (item.item_no !== 0 && userID && userToken) {
            const deleteFormData = {
              ...updatedFormData,
              product_id: item.product_id,
              item_no: item.item_no,
            };
            const response = await DeleteEditSaleOrderProduct(
              deleteFormData,
              userID,
              userToken
            );

            if (response.status !== 200) {
              console.error(`Product ${item.product_id} failed to remove.`);
            }
          }
        })
      );
    } catch (error) {
      console.error("Error during product removal:", error);
      alert("An error occurred during product removal.");
    }
  };

  const handleDeleteClick = async (index) => {
    TimeoutUtility.resetTimeout();
    const removedProduct = CardList[index];
    if (removedProduct.shipment === 0) {
      if (
        window.confirm(
          `Do you want to remove ${removedProduct.code} from Cart?`
        )
      ) {
        setdeleteprodList((prevArray) => [
          ...prevArray,
          {
            product_id: removedProduct.product_id,
            item_no: removedProduct.item_no,
          },
        ]);
        const item1 = CardList[index].product_id;
        const newCartList = [...CardList];
        newCartList.splice(index, 1);
        setcartList(newCartList);

        const currentIdsArray = ProductStr.split(" ");
        const updatedIdsArray = currentIdsArray.filter(
          (id) => id !== String(item1)
        );
        const updatedProductIds = updatedIdsArray.join(" ");
        setProductStr(updatedProductIds);
      }
    } else {
      alert("Ship qty is greater than zero. So, it could not be deleted.");
    }
  };

  const customFilter = (option, inputValue) => {
    const optionSearchField = String(option.value).toLowerCase();
    const lowerCasedInput = inputValue.toLowerCase();
    return optionSearchField.includes(lowerCasedInput);
  };

  function truncate(source, size) {
    return source.length > size ? source.slice(0, size - 1) + "…" : source;
  }

  const handleInputChange = (inputValue) => {
    if (customer_ids) {
      if (inputValue && inputValue.length >= 2 && userID && userToken) {
        const searchResults = getProductFilterSubString(
          store_id_param,
          inputValue,
          ProductStr,
          userID,
          userToken
        );
        searchResults
          .then((response) => {
            const productsArray = response.data;
            // const filteredProducts = productsArray.filter(
            //   (product) =>
            //     !CardList.some((item) => item.product_id === product.product_id)
            // );
            // const newProductOptions = filteredProducts.map((item) => ({
            const filteredProducts = productsArray.filter(
              (product) =>
                new Date(product.open_datetime) <= new Date(oDatetime)
            );
            const newProductOptions = filteredProducts.map((item) => ({
              values: item.product_id,
              price: item.unit_price,
              last_so_info:
                "Last Price: " +
                (item.last_price || "-") +
                " - SO#" +
                (item.last_so_id || "-") +
                " - SaleDate: " +
                (item.last_sale_date
                  ? new Date(item.last_sale_date).toISOString().split("T")[0]
                  : "-"),
              value: `${item.code} ${item.productname} ${
                item.details
              } ${formatCurrency(item.unit_price)}`.toLowerCase(),
              label: (
                <div
                  style={{
                    display: "flex",
                    marginTop: "4px",
                  }}
                >
                  {defaultImageMode &&
                    imageMode &&
                    (item.image || item.image_url) && (
                      <div
                        style={{
                          flex: "0 0 10%",
                        }}
                      >
                        <img
                          className="rounded-xl"
                          src={
                            item.image_url
                              ? `${item.image_url}`
                              : `data:image/jpeg;base64,${item.image}`
                          }
                          alt={`Product ${item.code}`}
                          style={{
                            maxWidth: "50px",
                            height: "50px",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    )}
                  <div
                    style={{
                      flex:
                        defaultImageMode &&
                        imageMode &&
                        (item.image || item.image_url)
                          ? "0 0 76%"
                          : "0 0 86%",
                      paddingLeft: "0px",
                    }}
                  >
                    <div>
                      <div style={{ fontWeight: "bold", fontSize: "16px" }}>{`${
                        item.code
                      } ${truncate(
                        item.productname,
                        defaultImageMode &&
                          imageMode &&
                          (item.image || item.image_url)
                          ? 44
                          : 50
                      )}`}</div>
                    </div>
                    <div style={{ fontSize: "14px" }}>{`${truncate(
                      item.details,
                      defaultImageMode &&
                        imageMode &&
                        (item.image || item.image_url)
                        ? 60
                        : 68
                    )}`}</div>
                  </div>
                  <div
                    style={{
                      flex: "0 0 14%",
                      fontWeight: "500",
                      color: currentColor,
                      textAlign: "right",
                      verticalAlign: "middle",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                      fontSize: "calc(0.6vw + 4px)",
                    }}
                  >{`${formatCurrency(item.unit_price)}`}</div>
                </div>
              ),
            }));
            setProductOptions(newProductOptions);
          })
          .catch((error) => {
            console.error("Error fetching products:", error);
          });
      } else {
        // setProductOptions(productOptions1);
      }
    }
  };

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (so_id_param && userID && userToken) {
        GetAccToIdBySaleOrder1(so_id_param, userID, userToken)
          .then((resp) => {
            setacc_from_bal(resp.data[0].end_balance);
          })
          .catch((err) => {
            console.log(err.message);
          });

        var errr = 0;
        GetSaleOrderCustomerByID(so_id_param, userID, userToken)
          .then((resp) => {
            if (resp.data[0].est_sale === "E") {
              setcusFlag(resp.data[0].name);
              setcustomer_ids(resp.data[0].customer_id);
              setstore_id_param(resp.data[0].store_id);
              setprojectname(resp.data[0].project_name);
              setprojectname1(resp.data[0].customer_po_no);
              settax(resp.data[0].tax);
              setnote(resp.data[0].so_note);
              setinvoice_id(resp.data[0].invoice_id);
              setprojectname2(resp.data[0].shipment);

              var d1 = new Date(resp.data[0].est_date);
              d1.setMinutes(d1.getMinutes() - d1.getTimezoneOffset());
              setODatetime(d1.toISOString().slice(0, 19));
            } else {
              errr = 1;
            }
          })
          .catch((err) => {
            console.log(err.message);
          });

        if (errr === 0) {
          GetSaleOrderDetailsByID(so_id_param, userID, userToken).then(
            function (result) {
              if (result.data) {
                const productList = result.data.map((item) => {
                  var reqDelDate = "";
                  if (item.req_delivery_date) {
                    reqDelDate = new Date(item.req_delivery_date);
                    reqDelDate.setMinutes(
                      reqDelDate.getMinutes() - reqDelDate.getTimezoneOffset()
                    );
                    reqDelDate = reqDelDate.toISOString().slice(0, 19);
                  }
                  return {
                    product_id: item.product_id,
                    name: item.product_name,
                    code: item.code,
                    unit_price: item.unit_price,
                    unit: item.unit,
                    quantity: item.quantity,
                    cost_price: item.cost_price,
                    discount: item.discount,
                    total: (item.unit_price - item.discount) * item.quantity,
                    item_no: item.item_no,
                    shipment: item.product_shipped,
                    image: item.image,
                    details: item.details,
                    notes: item.item_note,
                    req_delivery_date: reqDelDate,
                  };
                });
                setcartList(() => [...(productList || [])]);
              }
            }
          );
        } else {
          alert("This Estimate has been converted to Sales Order!");
          window.close();
        }
      }
    }
    fetchData();
  }, [so_id_param, userID, userToken]);

  useEffect(() => {
    const fetchUnitOptions = async () => {
      if (GetUnit && GetUnit.length > 0) {
        const fetchedOption = [];
        fetchedOption.push({
          label: `${GetUnit[0].name}`,
          value: GetUnit[0].unit_id,
          conv: parseFloat(GetUnit[0].conv_rate),
        });
        if (GetUnit[0].parent) {
          fetchedOption.push({
            label: `${GetUnit[0].pname}`,
            value: GetUnit[0].parent,
            conv: 1 / parseFloat(GetUnit[0].conv_rate),
          });
        }
        setUnitOptions(fetchedOption);
        if (fetchedOption[0]) {
          setSelectedUnit(fetchedOption[0]);
        }
      }
    };
    fetchUnitOptions();
  }, [GetUnit]);

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    CalculateAllFields();
  }, [CardList, tax, projectname2]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      maxHeight: "70px",
      height: "70px",
      fontSize: "14px",
    }),
    option: (provided) => ({
      ...provided,
      maxHeight: "70px",
      fontSize: "14px",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "250px",
    }),
  };

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 bg-white rounded-3xl">
      {isPageFrozen && <div className="overlay-freeze" />}
      <Container fluid className="g-0 p-0 justify-end">
        <Row
          xs={1}
          sm={1}
          className="justify-content-center"
          style={{ padding: "0" }}
        >
          <Col md={7} className="container-col">
            <Header title="EDIT ESTIMATION" />
          </Col>
          <Col md={2} className="container-col">
            <label className="label" style={{ fontSize: "12px" }}>
              <span style={{ paddingLeft: "8px" }}>Estimation DateTime:</span>
            </label>
            <input
              disabled
              className="input"
              id="o_date"
              type="datetime-local"
              style={{
                textAlign: "left",
                fontSize: "12px",
                width: "178px",
                background: "lightgray",
              }}
              value={oDatetime}
            />
          </Col>
          <Col md={3} className="container-col">
            <label
              style={{
                marginLeft: "32px",
                fontWeight: "bold",
                fontSize: "18px",
                backgroundColor: currentColor,
                color: "white",
                padding: "4px",
                paddingLeft: "8px",
                paddingRight: "8px",
                borderRadius: "5px",
              }}
            >
              E# {so_id_param}
            </label>
          </Col>
        </Row>
        <Row
          xs={1}
          sm={1}
          className="justify-content-center"
          style={{ padding: "0" }}
        >
          <Col md={9} className="container-col">
            <div className="card-sale">
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ padding: "0" }}
              >
                <Col md={12} className="container-col">
                  <label className="label" style={{ fontSize: "18px" }}>
                    Customer:
                  </label>
                  <div className="sale-input-div">
                    <div className="sale-input">
                      <input
                        className="input"
                        style={{
                          width: "100%",
                          height: "36px",
                        }}
                        type="text"
                        value={cusFlag}
                        readOnly
                        disabled
                      />
                    </div>
                    <div
                      className="sale-bal ml-4"
                      style={{ backgroundColor: currentColor }}
                    >
                      <label>{formatCurrency(acc_from_bal)}</label>
                    </div>
                  </div>
                </Col>
              </Row>
              <br />
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ padding: "0" }}
              >
                <Col md={12} className="container-col">
                  <div style={{ display: "flex" }}>
                    <label
                      htmlFor="product"
                      className="label"
                      style={{ fontSize: "18px", flex: "50%" }}
                    >
                      Product:
                    </label>
                    <label
                      className="label"
                      style={{ fontSize: "18px", flex: "14.5%" }}
                    >
                      Unit:
                    </label>
                    <label
                      className="label"
                      style={{ fontSize: "18px", flex: "12%" }}
                    >
                      Quantity:
                    </label>
                    <label
                      className="label"
                      style={{ fontSize: "18px", flex: "23.5%" }}
                    >
                      Price:
                    </label>
                    {/* <label
                      className="label"
                      style={{ fontSize: "18px", flex: "26%" }}
                    >
                      Supplier:
                    </label> */}
                  </div>
                  <div className="sale-input-div">
                    <div className="sale-input">
                      <Select
                        inputId="product"
                        className="myreact-select-prod"
                        menuPlacement="bottom"
                        menuPosition="fixed"
                        value={selectedProduct}
                        onChange={handleChangeProduct}
                        options={productOptions}
                        isSearchable
                        placeholder="Search Product With Name / Code"
                        styles={customStyles}
                        filterOption={customFilter}
                        onInputChange={handleInputChange}
                      />
                      <Select
                        className="myreact-select-unit"
                        inputId="unit"
                        menuPlacement="bottom"
                        menuPosition="fixed"
                        value={selectedUnit}
                        onChange={handleChangeUnit}
                        options={UnitOptions}
                        isSearchable
                        placeholder="Unit"
                        styles={customStyles}
                        onKeyDown={(event) =>
                          handleChangeUnit1(selectedUnit, event)
                        }
                      />
                      <input
                        id="qty"
                        type="number"
                        step="1"
                        min="0"
                        max="1000000"
                        className="input myreact-select-prod-qty"
                        //defaultValue={1.0}
                        value={qty}
                        placeholder="Quantity"
                        onClick={() => handleInputClick("qty", -8)}
                        onChange={handleChangeQty}
                        onKeyDown={handleEnterQty}
                      />
                      <input
                        id="uprice"
                        type="number"
                        step="1"
                        min="0"
                        max="1000000"
                        className="input myreact-select-prod-price"
                        //defaultValue={1.0}
                        value={unitPrice}
                        placeholder="Unit Price"
                        onClick={() => handleInputClick("uprice", -9)}
                        onChange={handleChangeUPrice}
                        onKeyDown={handleEnterUPrice}
                      />
                      {/* <Select
                        className="myreact-select-supp"
                        inputId="supplier"
                        menuPlacement="bottom"
                        menuPosition="fixed"
                        value={selectedSupplier}
                        onChange={handleChangeSupplier}
                        options={SupplierOptions}
                        isSearchable
                        placeholder="Product Supplier"
                        isClearable
                        styles={customStyles}
                        onKeyDown={(event) =>
                          handleChangeSupplier1(selectedSupplier, event)
                        }
                      /> */}
                    </div>
                    <button
                      className="sale-bal ml-4"
                      type="button"
                      style={{
                        backgroundColor: currentColor,
                        fontWeight: "1000",
                        fontSize: "18px",
                        height: "100%",
                      }}
                      onClick={handleAddcartClick}
                    >
                      +
                    </button>
                  </div>
                </Col>
              </Row>
              <br />
              <Row className="container-col">
                <Col md={8} className="mt-1 right-table-field">
                  <label className="pl-4">
                    {selectedProduct?.last_so_info}
                  </label>
                </Col>
              </Row>
              <Row
                xs={1}
                sm={1}
                className="justify-content-center table-container-sale"
              >
                <div className="m-0 p-0">
                  <table className="table table-striped table-bordered">
                    <thead>
                      <tr className="table-sale-tr">
                        <th style={{ width: "80px" }}>CODE</th>
                        <th style={{ width: "320px" }}>PRODUCT</th>
                        <th style={{ width: "60px" }}>UNIT</th>
                        <th style={{ width: "65px" }}>QTY</th>
                        <th style={{ width: "75px" }}>PRICE</th>
                        <th style={{ width: "75px" }}>DISC</th>
                        <th style={{ width: "75px" }}>TOTAL</th>
                        {/* <th style={{ width: "90px" }}>SUPPLIER</th>
                        <th style={{ width: "110px" }}>REQ DATE</th> */}
                        <th style={{ width: "280px" }}>NOTES</th>
                        <th style={{ width: "35px" }}>DEL</th>
                      </tr>
                    </thead>
                    <tbody className="pos-table-body">
                      {CardList?.map((item, index) => (
                        <tr key={index}>
                          <td onClick={() => handleToggle(item)}>
                            {item.code}
                          </td>
                          <td onClick={() => handleToggle(item)}>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                              {defaultImageMode &&
                                imageMode &&
                                (item.image || item.image_url) && (
                                  <div
                                    className="image flex gap-4"
                                    style={{
                                      maxWidth: "72px",
                                      height: "72px",
                                      flex: "0 0 20%",
                                    }}
                                  >
                                    <img
                                      className="rounded-xl"
                                      src={
                                        item.image_url
                                          ? `${item.image_url}`
                                          : `data:image/jpeg;base64,${item.image}`
                                      }
                                      alt={`Product ${item.code}`}
                                    />
                                  </div>
                                )}
                              <div
                                style={{
                                  flex:
                                    defaultImageMode &&
                                    imageMode &&
                                    (item.image || item.image_url)
                                      ? "0 0 80%"
                                      : "0 0 100%",
                                  paddingTop:
                                    !(
                                      defaultImageMode &&
                                      imageMode &&
                                      (item.image || item.image_url)
                                    ) && "8px",
                                  paddingBottom:
                                    !(
                                      defaultImageMode &&
                                      imageMode &&
                                      (item.image || item.image_url)
                                    ) && "7px",
                                  alignSelf: "center",
                                }}
                              >
                                <div style={{ fontWeight: "bold" }}>
                                  {truncate(
                                    item.name,
                                    defaultImageMode &&
                                      imageMode &&
                                      (item.image || item.image_url)
                                      ? 38
                                      : 44
                                  )}
                                </div>
                                <div>
                                  {truncate(
                                    item.details,
                                    defaultImageMode &&
                                      imageMode &&
                                      (item.image || item.image_url)
                                      ? 78
                                      : 88
                                  )}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>{item.unit}</td>
                          <td>
                            <div className="centered-input">
                              <input
                                className="input"
                                id="quantity"
                                type="number"
                                step="1.00"
                                min="0"
                                value={item.quantity}
                                onClick={() =>
                                  handleInputClick("quantity", index)
                                }
                                onChange={(e) =>
                                  handleQuantityChange(index, e.target.value)
                                }
                              />
                            </div>
                          </td>
                          <td>
                            <div className="centered-input">
                              <input
                                className="input"
                                id="unit_price"
                                type="number"
                                step="1.00"
                                min="0"
                                value={item.unit_price}
                                onClick={() =>
                                  handleInputClick("unit_price", index)
                                }
                                onChange={(e) =>
                                  handleUnitPriceChange(index, e.target.value)
                                }
                              />
                            </div>
                          </td>
                          <td>
                            <div className="centered-input">
                              <input
                                className="input"
                                id="discount"
                                min="0"
                                max={item.unit_price}
                                type="number"
                                step="1.00"
                                value={item.discount}
                                onClick={() =>
                                  handleInputClick("discount", index)
                                }
                                onChange={(e) =>
                                  handleDiscountChange(index, e.target.value)
                                }
                              />
                            </div>
                          </td>
                          <td>{formatCurrency(item.total)}</td>
                          {/* <td>{item.supplier_name}</td>
                          <td>
                            <div className="centered-input">
                              <input
                                className="input"
                                id="req_date"
                                type="date"
                                value={item.req_delivery_date}
                                onChange={(e) =>
                                  handleChangeReqDate(index, e.target.value)
                                }
                              />
                            </div>
                          </td> */}
                          <td>
                            <div className="centered-input">
                              <textarea
                                className="textarea"
                                id="notes"
                                type="text"
                                maxLength={250}
                                value={item.notes}
                                onClick={() => handleInputClick("notes", index)}
                                onChange={(e) =>
                                  handleNotesChange(index, e.target.value)
                                }
                              />
                            </div>
                          </td>
                          <td>
                            <button onClick={() => handleDeleteClick(index)}>
                              ❌
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Row>
              <Row
                xs={1}
                sm={1}
                className="justify-content-center table-container-sale1"
              >
                <table className="borderless w-100 h-100">
                  <tbody>
                    <tr>
                      <td
                        className="table-sum-label"
                        style={{ paddingTop: "8px" }}
                      >
                        SUB TOTAL:
                      </td>
                      <td
                        className="table-sum-cash"
                        style={{ color: currentColor, paddingTop: "8px" }}
                      >
                        {formatCurrency(total_amount)}
                      </td>
                      <td
                        className="table-grand-sum"
                        rowSpan="8"
                        style={{ backgroundColor: currentColor }}
                      >
                        <div className="tgs-label">
                          GRAND TOTAL
                          <br />
                          <span className="tgs-value">
                            {formatCurrency(grandtotal)}
                          </span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="table-sum-label">DISCOUNT:</td>
                      <td
                        className="table-sum-cash"
                        style={{ color: currentColor }}
                      >
                        {formatCurrency(totaldiscount)}
                      </td>
                    </tr>
                    <tr>
                      <td className="table-sum-label">TAX:</td>
                      <td className="table-sum-cash">
                        <label style={{ color: currentColor }}>{"%"}</label>
                        <input
                          id="tax"
                          type="number"
                          step="1"
                          min="0"
                          max="100"
                          className="input table-sum-tb"
                          value={tax}
                          onClick={() => handleInputClick("tax", -2)}
                          onChange={handleChangeTax}
                          style={{ color: currentColor }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="table-sum-label">SHIPPING:</td>
                      <td className="table-sum-cash">
                        <label style={{ color: currentColor }}>{"$"}</label>
                        <input
                          type="number"
                          name="shipment"
                          min="0"
                          step="1.00"
                          value={projectname2}
                          onChange={handleChangeProjectName2}
                          onClick={() => handleInputClick("shipment1", -3)}
                          className="input table-sum-tb"
                          style={{ marginLeft: "13px", color: currentColor }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td
                        className="table-sum-label"
                        style={{ marginBottom: "8px" }}
                      >
                        TOTAL ITEMS:
                      </td>
                      <td
                        className="table-sum-cash"
                        style={{ color: currentColor, marginBottom: "8px" }}
                      >
                        {total_item || 0}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Row>
            </div>
          </Col>
          <Col md={3} className="container-col">
            <div className="card-sale">
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ padding: "0px" }}
              >
                <Col
                  md={6}
                  className="container-col"
                  style={{ paddingRight: "5px", paddingBottom: "10px" }}
                >
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handleSaleOrderClick}
                  >
                    <div className="action-btn">SAVE</div>
                  </Card>
                </Col>
                <Col
                  md={6}
                  className="container-col"
                  style={{ paddingLeft: "5px", paddingBottom: "10px" }}
                >
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handlePrintOrderClick}
                  >
                    <div className="action-btn">SAVE & PRINT</div>
                  </Card>
                </Col>
              </Row>
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ padding: "0px" }}
              >
                <Col
                  md={6}
                  className="container-col"
                  style={{ paddingRight: "5px", paddingBottom: "10px" }}
                >
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handleNewClick}
                  >
                    <div className="action-btn">NEW</div>
                  </Card>
                </Col>
                <Col
                  md={6}
                  className="container-col"
                  style={{ paddingLeft: "5px", paddingBottom: "10px" }}
                >
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handleClearClick}
                  >
                    <div className="action-btn">CLEAR</div>
                  </Card>
                </Col>
              </Row>
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ padding: "0px" }}
              >
                <Col
                  md={6}
                  className="container-col"
                  style={{ paddingRight: "5px", paddingBottom: "10px" }}
                >
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handleViewEmployeesClick2}
                  >
                    <div className="action-btn">CONVERT TO SALES</div>
                  </Card>
                </Col>
                <Col
                  md={6}
                  className="container-col"
                  style={{ paddingLeft: "5px", paddingBottom: "10px" }}
                >
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handleBackClick}
                  >
                    <div className="action-btn">EXIT</div>
                  </Card>
                </Col>
              </Row>
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ paddingLeft: "16px", paddingRight: "16px" }}
              >
                <Col md={6} className="container-col right-table-field">
                  <label>Contact:</label>
                  <input
                    type="text"
                    name="project name"
                    value={projectname}
                    onChange={handleChangeProjectName}
                    placeholder="Contact"
                    className="input"
                  />
                </Col>
                <Col md={6} className="container-col right-table-field">
                  <label>Customer PO:</label>
                  <input
                    type="text"
                    name="Customer_po"
                    value={projectname1}
                    onChange={handleChangeProjectName1}
                    placeholder="Customer PO"
                    className="input"
                  />
                </Col>
                <Col
                  md={12}
                  className="container-col  right-table-field"
                  style={{ paddingTop: "4px", paddingBottom: "16px" }}
                >
                  <textarea
                    placeholder="Estimation Note"
                    id="noteTextarea"
                    value={note}
                    onChange={handleChangeNote}
                    className="textarea"
                  />
                </Col>
              </Row>
              <Row
                xs={1}
                sm={1}
                className="justify-content-center"
                style={{ padding: "0px" }}
              >
                {keypadButtons.map((number, index) => (
                  <Col md={4} className="container-col" key={index}>
                    <Card
                      className="keypad-button1"
                      style={{
                        border: "1px solid " + currentColor,
                        color: currentColor,
                      }}
                      key={number}
                      onClick={() => handleKeypadClick(number)}
                    >
                      {number}
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
          {/* {toggle && (
            <div className="overlay1">
              <Sidebar
                close={() => setToggle(false)}
                product_id={productID}
                store_id={store_id_param}
              />
            </div>
          )} */}
        </Row>
      </Container>
    </div>
  );
};
export default EditEstimation;
